import { MenuItemType, PageTypeSuffix } from '@/constants'
import type { SubMenu } from '@/types'
import { type Menu } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { Tab } from '@headlessui/react'
import Link from 'next/link'
import { useState } from 'react'
import ImageOptimize from '../ImageOptimize'
interface MegaMenuProps {
  placeholder?: string
  className?: string
  isError?: boolean | string
  id?: string
  name?: string
  children?: JSX.Element[] | JSX.Element
  alert?: boolean
  value?: string
  icon?: JSX.Element
  megaMenuData: Menu[]
  closeModal: () => void
}

export const MegaMenu = ({ megaMenuData, closeModal }: MegaMenuProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const checkUrlType = (item: Menu | SubMenu) => {
    switch (item.type) {
      case MenuItemType.PRODUCT_CAT:
        return '/' + item.slug + PageTypeSuffix.CATEGORY
      case MenuItemType.POST_CAT:
        return '/' + item.slug + PageTypeSuffix.CATEGORY
      case MenuItemType.POST:
        return '/' + item.slug + PageTypeSuffix.POST
      case MenuItemType.PAGE_CMS:
        return '/' + item.slug + PageTypeSuffix.PAGE_CMS
      case MenuItemType.PRODUCT:
        return '/' + item.slug
      case MenuItemType.LINK:
        return item.url
      default:
        return '/'
    }
  }
  return (
    <>
      <Tab.Group
        vertical
        selectedIndex={selectedIndex}
        onChange={setSelectedIndex}
        as={'div'}
        className={'flex justify-between'}
      >
        <Tab.List
          className={
            'max-w-[148px] flex-[148px] gap-1 max-h-[100vh] min-h-[100vh] hiddenScrollBar bg-white-500 overflow-y-auto pb-8'
          }
        >
          {megaMenuData
            .sort((a, b) => (a.order > b.order ? 1 : -1))
            .map((e, i) => {
              return (
                <Tab
                  key={i}
                  as={'div'}
                  className={
                    'tabItemMega ui-selected:border-l-[3px] border-b border-b-gray-500/50 ui-selected:font-bold ui-selected:border-l-primary-base ui-selected:bg-pink-200 text-sm outline-0'
                  }
                >
                  <div className='relative flex flex-col justify-center px-3 h-12'>
                    <div className='ui-selected:block absolute right-0 top-[50%] z-10 hidden h-0 w-0 translate-y-[-50%] border-b-[6px] border-r-[8px] border-t-[6px] border-b-transparent border-r-white border-t-transparent'></div>

                    <span className='title text-xs leading-4'>
                      {getTranslate(e.name)}
                    </span>
                  </div>
                </Tab>
              )
            })}
        </Tab.List>
        <Tab.Panels
          className={
            'flex-1 px-3 max-h-[calc(100vh-64px)] hiddenScrollBar overflow-y-auto pt-4 pb-8'
          }
        >
          {megaMenuData
            .sort((a, b) => (a.order > b.order ? 1 : -1))
            .map((e, i) => {
              return (
                <Tab.Panel key={i}>
                  <div className='flex flex-col flex-wrap'>
                    <div className='header mb-4 flex w-full items-center justify-between'>
                      <h6 className='title text-sm font-medium'>
                        {getTranslate(e.name) + ' giá tại kho'}
                      </h6>
                    </div>

                    <div className='main grid grid-cols-3 gap-3 pb-20'>
                      {e.children
                        .sort((a, b) => (a.order > b.order ? 1 : -1))
                        .map((child, index) => {
                          return (
                            <Link
                              key={index}
                              onClick={closeModal}
                              href={checkUrlType(child) || '/'}
                              className={'outline-0'}
                            >
                              <div className='flex flex-col justify-center'>
                                <div className='icon px-2 mb-2'>
                                  <ImageOptimize
                                    src={child.icon || '/'}
                                    alt={getTranslate(child.name)}
                                    width={110}
                                    height={110}
                                    thumbnail
                                    loading='lazy'
                                  />
                                </div>
                                <span className='text-dark line-clamp-2 h-[28px] text-center block overflow-hidden text-ellipsis text-textSmall text-dark-400'>
                                  {getTranslate(child.name)}
                                </span>
                              </div>
                            </Link>
                          )
                        })}
                    </div>
                  </div>
                </Tab.Panel>
              )
            })}
        </Tab.Panels>
      </Tab.Group>
    </>
  )
}
